module.exports = __webpack_public_path__ + "media/packs/whalewisdom/assets/images/main-logo-96cc69b3b85d6b820bdb0864f55f7378.png";